import { NOOP } from '@dadohr/shared/domainTypes/emptyConstants';
import { useTheme } from '@emotion/react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useId } from '../../hooks/useId';
import { TableCellLoader } from '../Table';

export type SelectCustomProps = SelectProps & {
  loading?: boolean;
  renderInitialValueImmediately?: boolean;
  helperText?: React.ReactNode;
};

const LOADER_SIZE = 12;
const LOADER_STYLE: React.CSSProperties = {
  position: 'absolute',
  right: '14px'
};

const Loader = () => {
  return (
    <TableCellLoader color="inherit" size={LOADER_SIZE} style={LOADER_STYLE} />
  );
};

export const SelectCustom = ({
  label,
  children: originalChildren,
  loading,
  renderInitialValueImmediately,
  error,
  helperText,
  ...props
}: SelectCustomProps) => {
  const { t } = useTranslation();
  const id = useId();
  const th = useTheme();
  const children =
    loading && !renderInitialValueImmediately ? (
      <MenuItem value="CUSTOM_SELECT_LOADING_STATE">{t('Loading')}...</MenuItem>
    ) : (
      originalChildren
    );

  return (
    <FormControl fullWidth={props.fullWidth}>
      <InputLabel
        id={id}
        variant="outlined"
        error={error}
        style={{
          background: th.palette.background.paper,
          padding: `0 ${th.spacing(0.5)}px`
        }}
      >
        {label}
      </InputLabel>
      <Select
        {...props}
        variant="outlined"
        labelId={id}
        error={error}
        IconComponent={loading ? Loader : undefined}
        renderValue={
          loading && !renderInitialValueImmediately
            ? undefined
            : props.renderValue
        }
        onChange={loading ? NOOP : props.onChange}
      >
        {children}
      </Select>
      {helperText && (
        <FormHelperText error={!!error}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};
